import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMembershipsFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M10.542 1.352a1 1 0 0 0-1.085 0l-1.43.923a1 1 0 0 1-.545.16L5.78 2.431a1 1 0 0 0-.913.587l-.703 1.55a1 1 0 0 1-.373.43l-1.434.916a1 1 0 0 0-.45.987l.246 1.685a1 1 0 0 1-.081.562l-.711 1.546a1 1 0 0 0 .154 1.075l1.118 1.283a1 1 0 0 1 .236.517l.238 1.686a1 1 0 0 0 .711.82l1.634.475a1 1 0 0 1 .479.308l1.11 1.289a1 1 0 0 0 1.042.306l1.632-.484a1 1 0 0 1 .569 0l1.631.484a1 1 0 0 0 1.042-.306l1.111-1.29a1 1 0 0 1 .478-.307l1.635-.475a1 1 0 0 0 .71-.82l.239-1.686a1 1 0 0 1 .236-.517l1.117-1.283a1 1 0 0 0 .155-1.075l-.711-1.546a1 1 0 0 1-.08-.562l.245-1.685a1 1 0 0 0-.45-.987l-1.434-.917a1 1 0 0 1-.373-.429l-.703-1.55a1 1 0 0 0-.913-.587l-1.702.004a1 1 0 0 1-.545-.16l-1.43-.923Zm2.98 7.687a.75.75 0 1 0-1.045-1.076l-3.335 3.242-1.62-1.575a.75.75 0 1 0-1.045 1.075l2.142 2.084a.75.75 0 0 0 1.046 0l3.857-3.75Z",
		clipRule: "evenodd"
	})
});
export default SvgMembershipsFilled;
